<template>
  <Form
    v-model="formData"
    @request="login"
    class="form__container"
    ref="form"
    :isNeedResets="false"
    name="login"
  >
    <img draggable="false" src="@/assets/img/logo.svg" alt="Газпром" />
    <h1>Вход</h1>
    <VInput
      autocomplete
      name="username"
      required
      placeholder="Логин"
      :not="errorLogin"
      @enter="login(formData)"
    />
    <VInput
      autocomplete
      name="password"
      type="password"
      required
      :not="errorPassword"
      placeholder="Пароль"
      style="margin-bottom: 12px"
      @enter="login(formData)"
    />
    <Checkbox v-model="remember" label="Запомнить на этом устройстве" />
    <Button
      type="submit"
      @click="hasError"
      :loading="isLoginning"
      width="400px"
      height="48px"
      text="Войти"
      class="btn-primary"
    />

    <transition name="fade">
      <div v-if="popup" @click="popup = false" class="error__popup">
        <b>Вход не выполнен</b>
        <div>{{ validationText }}</div>
      </div>
    </transition>
  </Form>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Button from "@/components/Button.vue";
import Checkbox from "@/components/Form/Checkbox.vue";

import Auth from "@/utils/auth.js";

export default {
  components: {
    Form,
    VInput,
    Button,
    Checkbox,
  },
  data() {
    return {
      isLoginning: false,
      popup: false,
      validationText: "",
      remember: false,
      errorLogin: "",
      errorPassword: "",
      formData: {},
    };
  },
  methods: {
    hasError() {
      const form = this.$refs.form;
      this.validationText = `Для входа введите корректные данные`;
      this.popup = form.hasValidationErrors();
    },
    login(data) {
      if(!this.$refs.form.hasValidationErrors()) {
        this.isLoginning = true;
        Auth.login(data.username, data.password)
          .then(() => {
            this.$router.push(Auth.unauthorizedTo || "/");
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.validationText = "Неверный логин или пароль";
              this.errorLogin = data.username;
              this.errorPassword = data.password;
            } else {
              this.validationText =
                "Произошла ошибка, пожалуйста, попробуйте позже";
            }

            this.popup = true;
          })
          .finally(() => {
            this.isLoginning = false;
          });
      } else this.hasError()
    },
  },
  watch: {
    popup(val) {
      if (val) setTimeout(() => (this.popup = false), 3000);
    },
    formData: {
      handler() {
        if (this.errorLogin || this.errorPassword) {
          this.errorLogin = "";
          this.errorPassword = "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.form__container {
  margin-top: 13%;
  max-width: 400px;
  text-align: center;
  row-gap: 12px;

  img {
    max-width: 334px;
    margin: 0 auto;
  }

  h1 {
    font-size: $size_xl;
    color: $dark-blue;
    margin: 20px auto 12px;
  }

  .error__popup {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    flex-direction: column;
    background: $red;
    width: 100%;
    border-radius: 4px;
    height: 80px;
    color: white;
    padding: 0 13px;
  }
}
</style>
